import { ListVariant } from './trade';

export enum BidStatus {
  none = 1,
  outbid = 2,
  topBidder = 3,
  proxy = 4
}

export const BidStatusName = {
  [BidStatus.none]: 'none',
  [BidStatus.outbid]: 'outbid',
  [BidStatus.topBidder]: 'top_bidder',
  [BidStatus.proxy]: 'proxy'
};

export const BidSource = {
  VDP_OVERLAY: 'VDP',
  VDP_BIDBOX: 'VDP BidBox',
  LIST_VIEW: 'list view',
  LIST_BIDBOX: 'list view BidBox',
  GRID_VIEW: 'grid view',
  MINI_VDP: 'mini VDP',
  MINI_VDP_BIDBOX: 'mini VDP BidBox'
};

export const ListVariantSource = {
  [ListVariant.LIST]: BidSource.LIST_VIEW,
  [ListVariant.GRID]: BidSource.GRID_VIEW
};

export enum BidConfirmationModalType {
  legal,
  overBidThreshold,
  overProxyThreshold,
  outbidDGN,
  outbidDealership
}

export const BidType = {
  manual: 'manual bid',
  quickBid: 'quick bid',
  proxy: 'proxy bid'
};
